"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var EarnList_1 = require("@pbl/pbl-react-web-components/lib/earn/v2/EarnList");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var page_container_1 = require("@pbl/pbl-react-web-components/lib/page-container");
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../config/constants"));
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/authentication/actions");
var actions_3 = require("../../redux/reducers/loyalty/actions");
var useActivityData_1 = require("../../shared/hooks/providers/earn/useActivityData");
var useNavigateToActivity_1 = require("../../shared/hooks/providers/earn/useNavigateToActivity");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var styles_1 = require("./styles");
var EarnScreen = function (_a) {
    var projectName = _a.projectName, titleComponent = _a.titleComponent;
    (0, useScrollToTop_1.useScrollToTop)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.styles)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = React.useState(false), pendingRedirect = _b[0], setPendingRedirect = _b[1];
    var navigateToActivity = (0, useNavigateToActivity_1.useNavigateToActivity)().navigateToActivity;
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _c.isAuthenticated, isRestricted = _c.isRestricted;
    var _d = (0, useActivityData_1.useActivityData)(isLoggedIn), activities = _d.activities, loading = _d.loading;
    React.useEffect(function () {
        dispatch((0, actions_2.isAuthenticated)());
        return function () {
            dispatch((0, actions_3.resetState)());
            dispatch((0, actions_1.clearMessages)());
        };
    }, [dispatch]);
    React.useEffect(function () {
        if (pendingRedirect && isLoggedIn) {
            navigateToTicketEntry();
            setPendingRedirect(false);
        }
    }, [isLoggedIn, pendingRedirect]);
    var navigateToTicketEntry = function () {
        if (!isLoggedIn && constants_1.default.V2_CHANGES) {
            var appNavigate = {
                action: 'LOGIN'
            };
            setPendingRedirect(true);
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
        else {
            var appNavigate = {
                action: 'TICKET_ENTRY'
            };
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
    };
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    return (React.createElement("div", { className: classes.container },
        React.createElement(page_container_1.Container, { title: React.createElement(package_1.Title, { icon: constants_1.default.HIDE_REWARD_EARN_LIST_ICON ? undefined : 'icon-KS-earn', title: projectName !== 'NC' ? 'Earn' : 'Earn Points', buttonText: constants_1.default.V2_CHANGES && projectName !== 'KS'
                    ? t('games.submitTicket')
                    : t('games.enterTicket'), buttonTextTitle: t('games.ticketEntry'), titleColor: 'textPrimary', navigateToTicketEntry: navigateToTicketEntry, disabled: isRestricted && isLoggedIn, isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs, titleComponent: titleComponent }) },
            React.createElement(EarnList_1.EarnList, { onActivitySelect: navigateToActivity, activities: activities, loading: loading }))));
};
exports.default = EarnScreen;
//# sourceMappingURL=index.js.map